import { ReactNode } from "react";
import { cn } from "@/utils/classes";

/* Prop Types */
interface TableCellProps {
  className?: string;
  truncate?: boolean;
  children: ReactNode;
}

/*
 * TableCell component
 */
export const TableCell = ({ className, truncate = true, children }: TableCellProps) => {
  /* Render */
  return (
    <td className="py-3 px-4">
      <div className={cn("flex flex-row gap-4 items-center text-sm", truncate && "truncate", className)}>{children}</div>
    </td>
  );
};
